var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGameFilter = function SvgGameFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "#fff"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#game-filter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.09 20.97c-.41 0-.75-.34-.75-.75V5.6c0-.41.34-.75.75-.75s.75.34.75.75v14.62c0 .41-.34.75-.75.75ZM10.65 7.57h-8.4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.4c.41 0 .75.34.75.75s-.34.75-.75.75ZM10.65 13.05h-8.4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.4c.41 0 .75.34.75.75s-.34.75-.75.75ZM6.31 18.53H2.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.06c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    style: {
      fill: "var(--fillg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.09 20.97c-.19 0-.38-.07-.53-.22l-3.65-3.65a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.12 3.12 3.13-3.12c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.66 3.65c-.15.14-.34.22-.53.22Z",
    style: {
      fill: "var(--fillg)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "game-filter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .91)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGameFilter;